import React from "react";
import { useTranslation } from "react-i18next";

function FormValidation({ value, showError, errorMsg }) {
  const { t } = useTranslation();

  const invalid = errorMsg ? showError : value === "" && showError;

  return (
    <div>
      {invalid && (
        <div className="mt-2 text-xs text-red-500">
          {errorMsg ? errorMsg : t("incompleteFormValidation")}
        </div>
      )}
    </div>
  );
}

export default FormValidation;
